"use strict";
exports.__esModule = true;
exports.Form = void 0;
var form_1 = require("./form");
exports.Form = form_1.Form;
exports["default"] = form_1.Form;
//# sourceMappingURL=index.js.map